import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const Lottie = ({
    animationData = null,
    width,
    height,
    className,
    loop = true,
    speed = 1,
    initialDelay = null,
    onCompleteCb,
    onFrame = null,
    id,
    paused = false,
    direction = 1,
    path = null,
}) => {
    const element = useRef(null);
    const lottieInstance = useRef();

    useEffect(() => {
        if (element.current && !lottieInstance.current) {
            if (animationData) {
                lottieInstance.current = lottie.loadAnimation({
                    animationData,
                    container: element.current,
                    loop: loop,
                });
            } else if (path) {
                lottieInstance.current = lottie.loadAnimation({
                    path,
                    container: element.current,
                    loop: loop,
                });
            }
            lottieInstance.current.setSpeed(speed);
            if (initialDelay) {
                lottieInstance.current.goToAndStop(0);
                setTimeout(() => {
                    lottieInstance.current.play();
                }, initialDelay);
            }
        }
    }, [animationData, loop, speed, initialDelay]);

    useEffect(() => {
        if (lottieInstance.current) {
            lottieInstance.current.onComplete = () => {
                if (onCompleteCb) {
                    onCompleteCb();
                }
            };
        }
    }, [onCompleteCb]);

    useEffect(() => {
        if (lottieInstance.current) {
            lottieInstance.current.setDirection(direction);
            lottieInstance.current.play();
        }
    }, [direction]);

    useEffect(() => {
        const callbacks = {};
        if (lottieInstance.current && onFrame) {
            onFrame.forEach(({ frame, callback }) => {
                callbacks[frame] = (anim) => {
                    if (anim.currentTime > frame) {
                        lottieInstance.current.removeEventListener(
                            'enterFrame',
                            callbacks[frame]
                        );
                        callback();
                    }
                };
                lottieInstance.current.addEventListener(
                    'enterFrame',
                    callbacks[frame]
                );
            });
        }

        return () => {
            if (callbacks) {
                for (let key in callbacks) {
                    lottieInstance.current.removeEventListener(
                        'enterFrame',
                        callbacks[key]
                    );
                }
            }
        };
    }, []);

    useEffect(() => {
        if (lottieInstance.current) {
            if (paused) {
                lottieInstance.current.pause();
            } else {
                lottieInstance.current.play();
            }
        }
    }, [paused]);

    return (
        <div
            style={{ width, height }}
            ref={element}
            className={className ? className : ''}
            id={id}
        ></div>
    );
};

export default Lottie;
